import type { ButtonDesignTokens } from '@primeuix/themes/types/button';

 export default {
    root: {
        lg: {
            fontSize: "1.125rem",
            paddingX: "0.875rem",
            paddingY: "0.625rem",
            iconOnlyWidth: "3rem"
        },
        sm: {
            fontSize: "0.875rem",
            paddingX: "0.625rem",
            paddingY: "0.375rem",
            iconOnlyWidth: "2rem"
        },
        gap: "0.5rem",
        label: {
            fontWeight: "{font.weight.medium}"
        },
        paddingX: "{form.field.padding.x}",
        paddingY: "{form.field.padding.y}",
        badgeSize: "1rem",
        focusRing: {
            style: "{focus.ring.style}",
            width: "{focus.ring.width}",
            offset: "{focus.ring.offset}"
        },
        borderRadius: "{form.field.border.radius}",
        raisedShadow: "0 3px 1px -2px rgba(0, 0, 0, 0.2),0 2px 2px 0 rgba(0, 0, 0, 0.14),0 1px 5px 0 rgba(0, 0, 0, 0.12)",
        iconOnlyWidth: "2rem",
        transitionDuration: "{form.field.transition.duration}",
        roundedBorderRadius: "2rem"
    },
    colorScheme: {
        dark: {
            link: {
                color: "{primary.color}",
                hoverColor: "{primary.color}",
                activeColor: "{primary.color}"
            },
            root: {
                help: {
                    color: "{purple.950}",
                    focusRing: {
                        color: "{purple.400}",
                        shadow: "0 0 0 0 #00000000"
                    },
                    background: "{purple.400}",
                    hoverColor: "{purple.950}",
                    activeColor: "{purple.950}",
                    borderColor: "{purple.400}",
                    hoverBackground: "{purple.300}",
                    activeBackground: "{purple.200}",
                    hoverBorderColor: "{purple.300}",
                    activeBorderColor: "{purple.200}"
                },
                info: {
                    color: "{blue.950}",
                    focusRing: {
                        color: "{blue.400}",
                        shadow: "0 0 0 0 #00000000"
                    },
                    background: "{blue.400}",
                    hoverColor: "{blue.950}",
                    activeColor: "{blue.950}",
                    borderColor: "{blue.400}",
                    hoverBackground: "{blue.300}",
                    activeBackground: "{blue.200}",
                    hoverBorderColor: "{blue.300}",
                    activeBorderColor: "{blue.200}"
                },
                warn: {
                    color: "{gold.950}",
                    focusRing: {
                        color: "{gold.400}",
                        shadow: "0 0 0 0 #00000000"
                    },
                    background: "{gold.400}",
                    hoverColor: "{gold.950}",
                    activeColor: "{gold.950}",
                    borderColor: "{gold.400}",
                    hoverBackground: "{gold.300}",
                    activeBackground: "{gold.200}",
                    hoverBorderColor: "{gold.300}",
                    activeBorderColor: "{gold.200}"
                },
                danger: {
                    color: "{red.950}",
                    focusRing: {
                        color: "{red.400}",
                        shadow: "0 0 0 0 #00000000"
                    },
                    background: "{red.400}",
                    hoverColor: "{red.950}",
                    activeColor: "{red.950}",
                    borderColor: "{red.400}",
                    hoverBackground: "{red.300}",
                    activeBackground: "{red.200}",
                    hoverBorderColor: "{red.300}",
                    activeBorderColor: "{red.200}"
                },
                primary: {
                    color: "{primary.contrast.color}",
                    focusRing: {
                        color: "{primary.color}",
                        shadow: "0 0 0 0 #00000000"
                    },
                    background: "{primary.color}",
                    hoverColor: "{primary.contrast.color}",
                    activeColor: "{primary.contrast.color}",
                    borderColor: "{primary.color}",
                    hoverBackground: "{primary.hover.color}",
                    activeBackground: "{primary.active.color}",
                    hoverBorderColor: "{primary.hover.color}",
                    activeBorderColor: "{primary.active.color}"
                },
                success: {
                    color: "{green.950}",
                    focusRing: {
                        color: "{green.400}",
                        shadow: "0 0 0 0 #00000000"
                    },
                    background: "{green.400}",
                    hoverColor: "{green.950}",
                    activeColor: "{green.950}",
                    borderColor: "{green.400}",
                    hoverBackground: "{green.300}",
                    activeBackground: "{green.200}",
                    hoverBorderColor: "{green.300}",
                    activeBorderColor: "{green.200}"
                },
                contrast: {
                    color: "{surface.950}",
                    focusRing: {
                        color: "{surface.0}",
                        shadow: "0 0 0 0 #00000000"
                    },
                    background: "{surface.0}",
                    hoverColor: "{surface.950}",
                    activeColor: "{surface.950}",
                    borderColor: "{surface.0}",
                    hoverBackground: "{surface.100}",
                    activeBackground: "{surface.200}",
                    hoverBorderColor: "{surface.100}",
                    activeBorderColor: "{surface.200}"
                },
                secondary: {
                    color: "{surface.300}",
                    focusRing: {
                        color: "{surface.300}",
                        shadow: "0 0 0 0 #00000000"
                    },
                    background: "{surface.800}",
                    hoverColor: "{surface.200}",
                    activeColor: "{surface.100}",
                    borderColor: "{surface.800}",
                    hoverBackground: "{surface.700}",
                    activeBackground: "{surface.600}",
                    hoverBorderColor: "{surface.700}",
                    activeBorderColor: "{surface.600}"
                }
            },
            text: {
                help: {
                    color: "{purple.400}",
                    hoverBackground: "color-mix(in srgb, {purple.400}, transparent 96%)",
                    activeBackground: "color-mix(in srgb, {purple.400}, transparent 84%)"
                },
                info: {
                    color: "{blue.400}",
                    hoverBackground: "color-mix(in srgb, {sky.400}, transparent 96%)",
                    activeBackground: "color-mix(in srgb, {blue.400}, transparent 84%)"
                },
                warn: {
                    color: "{gold.400}",
                    hoverBackground: "color-mix(in srgb, {gold.400}, transparent 96%)",
                    activeBackground: "color-mix(in srgb, {gold.400}, transparent 84%)"
                },
                plain: {
                    color: "{surface.0}",
                    hoverBackground: "{surface.800}",
                    activeBackground: "{surface.700}"
                },
                danger: {
                    color: "{red.400}",
                    hoverBackground: "color-mix(in srgb, {red.400}, transparent 96%)",
                    activeBackground: "color-mix(in srgb, {red.400}, transparent 84%)"
                },
                primary: {
                    color: "{primary.color}",
                    hoverBackground: "color-mix(in srgb, {primary.color}, transparent 96%)",
                    activeBackground: "color-mix(in srgb, {primary.color}, transparent 84%)"
                },
                success: {
                    color: "{green.400}",
                    hoverBackground: "color-mix(in srgb, {green.400}, transparent 96%)",
                    activeBackground: "color-mix(in srgb, {green.400}, transparent 84%)"
                },
                contrast: {
                    color: "{surface.0}",
                    hoverBackground: "{surface.800}",
                    activeBackground: "{surface.700}"
                },
                secondary: {
                    color: "{surface.400}",
                    hoverBackground: "{surface.800}",
                    activeBackground: "{surface.700}"
                }
            },
            outlined: {
                help: {
                    color: "{purple.400}",
                    borderColor: "{purple.700}",
                    hoverBackground: "color-mix(in srgb, {purple.400}, transparent 96%)",
                    activeBackground: "color-mix(in srgb, {purple.400}, transparent 84%)"
                },
                info: {
                    color: "{blue.400}",
                    borderColor: "{blue.700}",
                    hoverBackground: "color-mix(in srgb, {blue.400}, transparent 96%)",
                    activeBackground: "color-mix(in srgb, {blue.400}, transparent 84%)"
                },
                warn: {
                    color: "{gold.400}",
                    borderColor: "{gold.700}",
                    hoverBackground: "color-mix(in srgb, {gold.400}, transparent 96%)",
                    activeBackground: "color-mix(in srgb, {gold.400}, transparent 84%)"
                },
                plain: {
                    color: "{surface.0}",
                    borderColor: "{surface.600}",
                    hoverBackground: "{surface.800}",
                    activeBackground: "{surface.700}"
                },
                danger: {
                    color: "{red.400}",
                    borderColor: "{red.700}",
                    hoverBackground: "color-mix(in srgb, {red.400}, transparent 96%)",
                    activeBackground: "color-mix(in srgb, {red.400}, transparent 84%)"
                },
                primary: {
                    color: "{primary.color}",
                    borderColor: "{primary.700}",
                    hoverBackground: "color-mix(in srgb, {primary.color}, transparent 96%)",
                    activeBackground: "color-mix(in srgb, {primary.color}, transparent 84%)"
                },
                success: {
                    color: "{green.400}",
                    borderColor: "{green.700}",
                    hoverBackground: "color-mix(in srgb, {green.400}, transparent 96%)",
                    activeBackground: "color-mix(in srgb, {green.400}, transparent 84%)"
                },
                contrast: {
                    color: "{surface.0}",
                    borderColor: "{surface.500}",
                    hoverBackground: "{surface.800}",
                    activeBackground: "{surface.700}"
                },
                secondary: {
                    color: "{surface.400}",
                    borderColor: "{surface.700}",
                    hoverBackground: "rgba(255, 255, 255, 0.04)",
                    activeBackground: "rgba(255, 255, 255, 0.16)"
                }
            }
        },
        light: {
            link: {
                color: "{primary.color}",
                hoverColor: "{primary.800}",
                activeColor: "{primary.900}"
            },
            root: {
                help: {
                    color: "{white}",
                    focusRing: {
                        color: "{purple.500}",
                        shadow: "0 0 0 0 #00000000"
                    },
                    background: "{purple.500}",
                    hoverColor: "{white}",
                    activeColor: "{white}",
                    borderColor: "{purple.500}",
                    hoverBackground: "{purple.600}",
                    activeBackground: "{purple.700}",
                    hoverBorderColor: "{purple.600}",
                    activeBorderColor: "{purple.700}"
                },
                info: {
                    color: "{white}",
                    focusRing: {
                        color: "{blue.500}",
                        shadow: "0 0 0 0 #00000000"
                    },
                    background: "{blue.500}",
                    hoverColor: "{white}",
                    activeColor: "{white}",
                    borderColor: "{blue.500}",
                    hoverBackground: "{blue.600}",
                    activeBackground: "{blue.700}",
                    hoverBorderColor: "{blue.600}",
                    activeBorderColor: "{blue.700}"
                },
                warn: {
                    color: "{white}",
                    focusRing: {
                        color: "{gold.500}",
                        shadow: "0 0 0 0 #00000000"
                    },
                    background: "{gold.500}",
                    hoverColor: "{white}",
                    activeColor: "{white}",
                    borderColor: "{gold.500}",
                    hoverBackground: "{gold.600}",
                    activeBackground: "{gold.700}",
                    hoverBorderColor: "{gold.600}",
                    activeBorderColor: "{gold.700}"
                },
                danger: {
                    color: "{white}",
                    focusRing: {
                        color: "{red.600}",
                        shadow: "0 0 0 0 #00000000"
                    },
                    background: "{red.600}",
                    hoverColor: "{white}",
                    activeColor: "{white}",
                    borderColor: "{red.600}",
                    hoverBackground: "{red.700}",
                    activeBackground: "{red.800}",
                    hoverBorderColor: "{red.700}",
                    activeBorderColor: "{red.800}"
                },
                primary: {
                    color: "{primary.contrast.color}",
                    focusRing: {
                        color: "{primary.color}",
                        shadow: "0 0 0 0 #00000000"
                    },
                    background: "{primary.color}",
                    hoverColor: "{primary.contrast.color}",
                    activeColor: "{primary.contrast.color}",
                    borderColor: "{primary.color}",
                    hoverBackground: "{primary.hover.color}",
                    activeBackground: "{primary.active.color}",
                    hoverBorderColor: "{primary.hover.color}",
                    activeBorderColor: "{primary.active.color}"
                },
                success: {
                    color: "{white}",
                    focusRing: {
                        color: "{green.500}",
                        shadow: "0 0 0 0 #00000000"
                    },
                    background: "{green.500}",
                    hoverColor: "{white}",
                    activeColor: "{white}",
                    borderColor: "{green.500}",
                    hoverBackground: "{green.600}",
                    activeBackground: "{green.700}",
                    hoverBorderColor: "{green.600}",
                    activeBorderColor: "{green.700}"
                },
                contrast: {
                    color: "{surface.0}",
                    focusRing: {
                        color: "{surface.950}",
                        shadow: "0 0 0 0 #00000000"
                    },
                    background: "{surface.950}",
                    hoverColor: "{surface.0}",
                    activeColor: "{surface.0}",
                    borderColor: "{surface.950}",
                    hoverBackground: "{surface.900}",
                    activeBackground: "{surface.800}",
                    hoverBorderColor: "{surface.900}",
                    activeBorderColor: "{surface.800}"
                },
                secondary: {
                    color: "{surface.600}",
                    focusRing: {
                        color: "{surface.600}",
                        shadow: "0 0 0 0 #00000000"
                    },
                    background: "{surface.100}",
                    hoverColor: "{surface.700}",
                    activeColor: "{surface.800}",
                    borderColor: "{surface.100}",
                    hoverBackground: "{surface.200}",
                    activeBackground: "{surface.300}",
                    hoverBorderColor: "{surface.200}",
                    activeBorderColor: "{surface.300}"
                }
            },
            text: {
                help: {
                    color: "{purple.500}",
                    hoverBackground: "{purple.50}",
                    activeBackground: "{purple.100}"
                },
                info: {
                    color: "{blue.500}",
                    hoverBackground: "{blue.50}",
                    activeBackground: "{blue.100}"
                },
                warn: {
                    color: "{gold.500}",
                    hoverBackground: "{gold.50}",
                    activeBackground: "{gold.100}"
                },
                plain: {
                    color: "{surface.700}",
                    hoverBackground: "{surface.50}",
                    activeBackground: "{surface.100}"
                },
                danger: {
                    color: "{red.500}",
                    hoverBackground: "{red.50}",
                    activeBackground: "{red.100}"
                },
                primary: {
                    color: "{primary.color}",
                    hoverBackground: "{primary.50}",
                    activeBackground: "{primary.100}"
                },
                success: {
                    color: "{green.500}",
                    hoverBackground: "{green.50}",
                    activeBackground: "{green.100}"
                },
                contrast: {
                    color: "{surface.950}",
                    hoverBackground: "{surface.50}",
                    activeBackground: "{surface.100}"
                },
                secondary: {
                    color: "{surface.500}",
                    hoverBackground: "{surface.50}",
                    activeBackground: "{surface.100}"
                }
            },
            outlined: {
                help: {
                    color: "{purple.500}",
                    borderColor: "{purple.200}",
                    hoverBackground: "{purple.50}",
                    activeBackground: "{purple.100}"
                },
                info: {
                    color: "{blue.500}",
                    borderColor: "{blue.200}",
                    hoverBackground: "{blue.50}",
                    activeBackground: "{blue.100}"
                },
                warn: {
                    color: "{gold.500}",
                    borderColor: "{gold.200}",
                    hoverBackground: "{gold.50}",
                    activeBackground: "{gold.100}"
                },
                plain: {
                    color: "{surface.700}",
                    borderColor: "{surface.200}",
                    hoverBackground: "{surface.50}",
                    activeBackground: "{surface.100}"
                },
                danger: {
                    color: "{red.500}",
                    borderColor: "{red.200}",
                    hoverBackground: "{red.50}",
                    activeBackground: "{red.100}"
                },
                primary: {
                    color: "{primary.color}",
                    borderColor: "{primary.color}",
                    hoverBackground: "{primary.50}",
                    activeBackground: "{primary.100}"
                },
                success: {
                    color: "{green.500}",
                    borderColor: "{green.200}",
                    hoverBackground: "{green.50}",
                    activeBackground: "{green.100}"
                },
                contrast: {
                    color: "{surface.950}",
                    borderColor: "{surface.700}",
                    hoverBackground: "{surface.50}",
                    activeBackground: "{surface.100}"
                },
                secondary: {
                    color: "{surface.500}",
                    borderColor: "{surface.200}",
                    hoverBackground: "{surface.50}",
                    activeBackground: "{surface.100}"
                }
            }
        }
    }
} satisfies ButtonDesignTokens;